import { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [pledges, setPledges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPledges();
  }, []);

  const fetchPledges = async () => {
    try {
      const response = await fetch('https://skyfarmisland-api.objekk.workers.dev/pledges');
      if (!response.ok) {
        throw new Error('Failed to fetch pledges');
      }
      const data = await response.json();
      setPledges(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const exportToCSV = () => {
    const headers = ['Display Name', 'Username', 'Country', 'I care about nature because..', 'Date'];
    const csvData = pledges.map(pledge => [
      pledge.display_name,
      pledge.username,
      pledge.country,
      pledge.pledge_option,
      new Date(pledge.timestamp * 1000).toLocaleDateString()
    ]);

    const csvContent = [
      headers.join(','),
      ...csvData.map(row => row.map(cell => `"${cell}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'sky_farm_island_pledges.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) {
    return <div className="container">Loading...</div>;
  }

  if (error) {
    return <div className="container error">Error: {error}</div>;
  }

  return (
    <div className="container">
      <div className="header">
        <img src="/logo.png" alt="Sky Farm Island Logo" className="logo" />
        <h1>Sky Farm Island All In For Nature Pledges</h1>
      </div>
      <div className="stats">
        <div className="stat-box">
          <h3>Total Pledges</h3>
          <p>{pledges.length}</p>
        </div>
        <div className="stat-box">
          <h3>Unique Countries</h3>
          <p>{new Set(pledges.map(pledge => pledge.country)).size}</p>
        </div>
      </div>
      <div className="export-container">
        <button onClick={exportToCSV} className="export-button">
          Export to CSV
        </button>
      </div>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Display Name</th>
              <th>Username</th>
              <th>Country</th>
              <th>I care about nature because..</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {pledges.map((pledge) => (
              <tr key={pledge.id}>
                <td>{pledge.display_name}</td>
                <td>@{pledge.username}</td>
                <td>{pledge.country}</td>
                <td>{pledge.pledge_option}</td>
                <td>{new Date(pledge.timestamp * 1000).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default App; 